import { createNamespacedHelpers } from "vuex";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	props: { svgPath: String },
	computed: { ...brandingGetters(["colors"]) },

	data() {
		return { imgSource: null };
	},

	created() {
		this.fetchData();
	},

	methods: {
		async fetchData() {
			const response = await fetch(this.svgPath);

			let svgContent = await response.text();

			for (let colorIndex = 0; colorIndex < Object.keys(this.colors).length; colorIndex++)
				svgContent = svgContent.replaceAll(`var(--color${colorIndex})`, this.colors[colorIndex]);

			this.imgSource = `data:image/svg+xml;base64,${Buffer.from(svgContent).toString("base64")}`;
		},
	},
};
